import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { OptionI18nInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "optionID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductOptionI18nFormModel = AutoGeneratorForFormModel<
	OptionI18nInputZodSchemaType,
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;
